<template>
  <div class="vote_box" v-if="showVoteResult">
    <div class="vote_result">已有<span v-text="vote.total"></span>投票</div>
    <div class="vote_title" v-text="vote.title"></div>
    <ul class="vote_list">
      <li class="vote_item" v-for="(item,index) in vote.itemList" :key="index">
        <div class="result_item">
          <label>
            <span>{{item.title}}</span>
            <img v-if="vote.supportPicture==1" :src="item.resourceUrl">
          </label>
          <div class="percentage_box">
            <div class="bar">
              <van-progress :color="progress[index%4]" :show-pivot="false" :percentage="(item.count*100/vote.total).toFixed(2)" />
            </div>
            <div class="per">{{(item.count*100/vote.total).toFixed(2) + "%"}}</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div class="vote_box" v-else>
    <div class="vote_title" v-text="vote.title"></div>
    <ul class="vote_list">
      <li class="vote_item" v-for="(item,index) in vote.itemList" :key="index">
        <div :class="vote.multiselect==1?'checkbox':'radio'">
          <input name="voteItemGroup" :type="vote.multiselect==1?'checkbox':'radio'" :id="'voteItem' + index" :checked="item.isDefault==1" :value="item.itemId" @change="onVoteItemChange">
          <label :for="'voteItem' + index">
            <span>{{item.title}}</span>
            <img v-if="vote.supportPicture==1" :src="item.resourceUrl">
          </label>
        </div>
      </li>
    </ul>
    <div class="vote_btn_box">
      <span class="vote_btn" @click="onVoteSubmit">提 交</span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepClone } from "@/utils";
import newsApi from "@/api/apis/news.js";
export default {
  name: "Vote",
  props: {
    voteInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      vote: null,
      showVoteResult: false,
      progress: ["#df3435", "#f5ce48", "#4cb4e4", "#ef9c18"],
    };
  },
  computed: {
    ...mapState("app", ["userInfo"]),
  },
  watch: {
    voteInfo: {
      handler(newValue, oldValue) {
        this.vote = deepClone(newValue);
      },
      deep: true,
    },
  },
  methods: {
    /* 验证是否已投票 */
    validateHasBallotOrNotByMember() {
      var _this = this;
      var params = {
        ballotId: _this.vote.voteId, // 投票id
        memberId: _this.userInfo.id, // 会员id
      };
      newsApi
        .validateHasBallotOrNotByMember(params)
        .then((res) => {
          if (res.suc == 1 && res.data.suc == 2) {
            _this.showVoteResult = true;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 检测投票多选限制选中项数量 */
    onVoteItemChange(event) {
      var _this = this;
      if (
        event.target.checked &&
        _this.vote.multiselect == 1 &&
        _this.vote.multiselectNumber > 0
      ) {
        var $doms = document.getElementsByName("voteItemGroup");
        var checkedNum = 0;
        for (var i = 0; i < $doms.length; i++) {
          if ($doms[i].checked) {
            checkedNum++;
          }
          if (
            i == $doms.length - 1 &&
            _this.vote.multiselectNumber < checkedNum
          ) {
            _this.$toast({
              message: "最多可选择" + _this.vote.multiselectNumber + "项",
              position: "center",
            });
            event.target.checked = false;
          }
        }
      }
    },
    /* 提交投票 */
    onVoteSubmit() {
      if (!!this.userInfo) {
        var _this = this;
        var itemIds = [];
        var $doms = document.getElementsByName("voteItemGroup");
        for (var i = 0; i < $doms.length; i++) {
          if ($doms[i].checked) {
            itemIds.push($doms[i].value);
          }
        }
        var params = {
          ballotId: _this.vote.voteId, // 投票id
          itemIds: itemIds.toString(), // 项目IDS
          memberId: _this.userInfo.id, // 会员ID
          sourceType: 4, // 1:苹果;2:安卓;3web;4:H5
          // deviceId: null,  // 设备号
          // deviceType: null, // 设备标识1:华为2:小米3:苹果
          // netIp: null, // ip地址
        };
        newsApi
          .addBallotData(params)
          .then((res) => {
            if (res.suc == 1) {
              _this.vote = res.data.vote;
              _this.showVoteResult = true;
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        this.$router.push("/login");
      }
    },
  },
  created() {
    this.vote = deepClone(this.voteInfo);
    if (!!this.userInfo) {
      this.validateHasBallotOrNotByMember();
    }
  },
};
</script>
<style scoped lang="scss">
.vote_box {
  padding-top: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ececec;
  margin-bottom: 16px;
  .vote_title {
    width: 100%;
    padding: 8px 0;
    line-height: 21px;
    color: #df3435;
  }
  .vote_list {
    .vote_item {
      padding: 4px 8px;
      .checkbox,
      .radio {
        line-height: 24px;
        img {
          display: block;
          width: 100%;
          padding-left: 18px;
          margin-top: 5px;
        }
      }
      .result_item {
        width: 100%;
        .percentage_box {
          display: flex;
          line-height: 24px;
          padding: 8px 0;
          .bar {
            flex: 1;
            width: 100%;
            padding-top: 10px;
          }
          .per {
            width: 60px;
            text-align: right;
          }
        }
        label{
          img{
            max-width: 100%;
            margin-top: 5px;
          }
        }
      }
    }
  }
  .vote_btn_box {
    .vote_btn {
      display: block;
      width: 100%;
      line-height: 32px;
      background: #e03335;
      border: 1px solid #e03335;
      border-radius: 3px;
      text-align: center;
      color: #fff;
      font-size: 14px;
    }
  }
}
</style>